import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuality = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path fill={props.fill} d="M35.772 2.5v34.375h-7.86V6.745l7.86-4.245Z" />
    <path
      fill="currentColor"
      d="M11.61 15.552v21.323H3.75V19.8l7.86-4.248Zm12.079-6.526v27.849h-7.86V13.274l7.86-4.248Z"
    />
  </svg>
);

export default SvgQuality;
